import React from 'react';
import HubspotForm from 'react-hubspot-form'

import Localization from '../../Localization';

export default function About(props) {
  const { setShow } = props;

  return (
    <div>
      <h1>{Localization.get('About / Data Download')}</h1>
      <div className='close' onClick={() => setShow(false)}>x</div>
      <div className='content'>
        {Localization.get('aboutText')}
        <HubspotForm
          portalId='8473896'
          formId='795811b8-8cb1-45c9-b638-8e0d7907b0a3'
          onSubmit={() => {}}
        />
      </div>
      <div className='button' onClick={() => setShow(false)}>
        <button>{Localization.get('Close')}</button>
      </div>
    </div>
  );
}